
export interface LicenseDetails {
    dealers: FFLGetLicenseDetail[];
}

interface FFLGetLicenseDetail {
    contact: Contact | null; 
    dealerId: string;
    slug: string;
    licenses:  Array<Licenses>;
    fullLicenseKey: string | null;
    supportedFirearms: Array<string>; 
    socialProfiles: SocialProfiles;
    isRangeDealer: boolean;
    hasEmails: boolean;
    primaryBusiness: boolean;
    optedInAllStores: boolean;
    optedOutAllStores: boolean;
    isPermanentlyClosed: boolean;
    isTemporarilyClosed: boolean;
    isBigBoxRetailer: boolean;
    phoneNumbers: Array<string>;
    orderScore: number | null;
    primaryBusinessName: string;
    isCommercial: boolean;
    isDeleted: boolean;
    address: Address;
    consolidatedRatings: ConsolidatedRatings;
    geoLocation: GeoLocation;
    openOnWeekends: boolean;
    operatingHoursText: Array<String>;
    certificateExpiry: number | null;
    optedInForStore: boolean;
    optedOutForStore: boolean;
    isBlacklisted: boolean;
    isPreferred: boolean;
    isStocking: boolean;
    primaryBusinessType: string | null;
    distance: number;
    licenseTypes:LicenseType;
    isSotDealer: boolean;
    primaryEmail: string;
    firearms: Firearms;
    sot: SOT;
    myffl: MyFFL;
}

export interface LicenseDetail { 
    contact: Contact | null; 
    dealer_id: string;
    slug: string;
    licenses: Array<Licenses>;
    supportedFirearms: Array<string>; 
    socialProfiles: SocialProfiles;
    isRange: boolean;
    hasEmails: boolean;
    primaryBusiness: boolean;
    optedInAllStores: boolean;
    optedOutAllStores: boolean;
    isPermanentlyClosed: boolean;
    isTemporarilyClosed: boolean;
    isBigBoxRetailer: boolean;
    phoneNumber: Array<string>;  
    orderScore: number | null;
    name:string;
    isCommercial: boolean;
    isDeleted: boolean;
    address: Address;
    consolidatedRatings: ConsolidatedRatings;
    geo: GeoLocation;
    openOnWeekends: boolean;
    operatingHoursText: Array<String>;
    certificateExpiry: number | null; //
    optedInForStore: boolean;
    optedOutForStore: boolean;
    isBlacklisted: boolean; 
    isPreferred: boolean; 
    isStockingDealer: boolean; 
    primaryBusinessType: string | null;
    distance: number;
    licenseTypes:LicenseType;
    isSotDealer: boolean;
    primaryEmail: string;
    firearms: Firearms;
    sot: SOT;
    myffl: MyFFL;
}
export interface LicenseType {
    licenseKey: string;
    type: string;
    fullLicenseKey: string;
    expiryDate: string;
    certificateExpiryDate: number | null;
    isDeleted: boolean;
    isPrimaryForOutbound: boolean;
    isPrimaryForInbound: boolean;
    hasValidCertificate?: boolean; 
}

interface Contact{
    isPrimary:boolean;
    title:string;
    value:string;
}

interface Licenses {
    licenseKey: string,
    type: string,
    fullLicenseKey: string;
    expiryDate: number;
    certificateExpiryDate:string | null,
    isDeleted: boolean,
    isPrimaryForOutbound: boolean,
    isPrimaryForInbound: boolean
}
interface Address {
    state: string;
    zipCode: string;
    street: string;
    city: string;
    citySlug: string;
    cityName: string;
}

interface ConsolidatedRatings {
    ratings: any | null; 
    reviews: number;
}

interface GeoLocation {
    lat: string;
    lon: string;
}

interface Firearms {
    handGun: string | null;
    longGun: string | null;
    other: string | null;
    nics: string | null;
    nfa: string | null;
    discountForMultipleFirearms: string | null;
}

interface SOT {
    employeeIdentificationNumber: string | null;
    licensePath: string | null;
}

interface MyFFL {
    subscription: string | "";
}

interface SocialProfiles {
    facebook: string | null;
    yelp: string | null;
    google: string | null;
}

export default class LicenseDetailBuilder {
    static buildLicenseDetailsForTransfer(i : FFLGetLicenseDetail) : LicenseDetail {
        
        const result: LicenseDetail = {
            contact:i.contact,
            dealer_id:i.dealerId, //
            slug: i.slug,
            licenses: i.licenses,
            supportedFirearms: i.supportedFirearms,
            socialProfiles: i.socialProfiles,
            isRange: i.isRangeDealer,//
            hasEmails: i.hasEmails,
            primaryBusiness: i.primaryBusiness,
            optedInAllStores: i.optedInAllStores,
            optedOutAllStores: i.optedOutAllStores,
            isPermanentlyClosed: i.isPermanentlyClosed,
            isTemporarilyClosed: i.isTemporarilyClosed,
            isBigBoxRetailer: i.isBigBoxRetailer,
            phoneNumber: i.phoneNumbers,//
            orderScore: i.orderScore,
            name:i.primaryBusinessName,//
            isCommercial: i.isCommercial,
            isDeleted: i.isDeleted,
            address: i.address,
            consolidatedRatings:i.consolidatedRatings, 
            geo:i.geoLocation,//
            openOnWeekends:i.openOnWeekends,
            operatingHoursText: i.operatingHoursText,
            certificateExpiry: i.certificateExpiry, //?
            optedInForStore:i.optedInForStore,
            optedOutForStore: i.optedOutForStore,
            isBlacklisted: i.isBlacklisted,//
            isPreferred: i.isPreferred,//
            isStockingDealer: i.isStocking,// 
            primaryBusinessType: i.primaryBusinessType,
            distance: i.distance,
            licenseTypes:i.licenseTypes,
            isSotDealer: i.isSotDealer,
            primaryEmail: i.primaryEmail,
            firearms: i.firearms,
            sot: i.sot,
            myffl:i.myffl
        } 
        return result;
    }
}
